import { render } from "./ShippingAddressConfirm.vue?vue&type=template&id=2e2f5a1b&ts=true"
import script from "./ShippingAddressConfirm.vue?vue&type=script&lang=ts"
export * from "./ShippingAddressConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_f60bedd5/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__